/*
  Send people back to the exact page they were on after signing in.

  Shopify's Liquid `request` object exposes `path` but has no `query_string`, so a
  server-rendered return_to can only ever carry the path. Verified on staging: a
  visitor on /collections/x-brands?page=2 got return_to=/collections/x-brands and
  lost their page, filters and sort on the way back.

  So the markup ships the path (correct with JS off, just less precise) and this
  restores the full URL. Runs once, rewrites every login link on the page — the
  strip's button and the CTA on each card.
*/
(function () {
  'use strict';

  var PREFIX = '/customer_authentication/login';

  function fix() {
    var here = window.location.pathname + window.location.search;
    var links = document.querySelectorAll('a[href^="' + PREFIX + '"]');
    for (var i = 0; i < links.length; i++) {
      links[i].setAttribute('href', PREFIX + '?return_to=' + encodeURIComponent(here));
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', fix);
  } else {
    fix();
  }
})();
